module.exports = __webpack_public_path__ + "img/zbsj.dd08355a.png";